import { batchActions } from "redux-batched-actions";
import { displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// api
import { asyncGetRatingsUnitCode } from 'utils/api/ratings';

// constants
export const RECEIVE_RATINGS_UNIT_CODE = 'RECEIVE_RATINGS_UNIT_CODE';
export const FETCHING_RATINGS_UNIT_CODE = 'FETCHING_RATINGS_UNIT_CODE';

// actions
const receiveRatingsUnitCode = data => ({
    type: RECEIVE_RATINGS_UNIT_CODE,
    data
});

const fetchingRatingsUnitCode = status => ({
    type: FETCHING_RATINGS_UNIT_CODE,
    status
});

// batched actions

const ratingsUnitCodeSuccess = (data) => batchActions([receiveRatingsUnitCode(data), fetchingRatingsUnitCode(false)]);
const ratingsUnitCodeFail = () => batchActions([displayErrorMessage('There was a problem fetching Ratings Unit Code.'), fetchingRatingsUnitCode(false)]);

// thunks

export const getRatingsUnitCode = (siteUUID, enablePageId) => dispatch => {
    dispatch(fetchingRatingsUnitCode(true))
    asyncGetRatingsUnitCode(siteUUID, enablePageId)
        .then(response => dispatch(ratingsUnitCodeSuccess(response.data)))
        .catch(err => dispatch(ratingsUnitCodeFail()))
};

